module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "list"
    }
  }, [_c('div', {
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creative-logs')))]), _c('template', {
    slot: "content"
  }, [(_vm.itemsList.length) ? _vm._l((_vm.itemsList), function(item) {
    return _c('div', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(item))])
  }) : [_vm._v("-")]], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a76cb210"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/creative-logs/CreativeLogs.vue
// module id = 2084
// module chunks = 1